import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PvPopoverAnchor = PopoverPrimitive.Anchor;
